import React from 'react';
import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';

const Routes = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Routes</h1>
        <p>Manage bus routes and schedules</p>
      </div>

      <div className="placeholder-content" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4rem 2rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '12px',
        border: '2px dashed #dee2e6',
        marginTop: '2rem'
      }}>
        <ArrowsRightLeftIcon style={{ 
          width: '80px', 
          height: '80px', 
          color: '#6c757d',
          marginBottom: '1.5rem'
        }} />
        <h2 style={{ 
          color: '#495057', 
          marginBottom: '0.5rem',
          fontSize: '1.75rem'
        }}>
          Routes Module Coming Soon
        </h2>
        <p style={{ 
          color: '#6c757d', 
          textAlign: 'center',
          maxWidth: '500px',
          lineHeight: '1.6'
        }}>
          This module will allow you to manage bus routes, stops, schedules, and driver assignments.
          Stay tuned for updates!
        </p>
        
        <div style={{
          marginTop: '2rem',
          padding: '1rem 2rem',
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          border: '1px solid #ffc107'
        }}>
          <p style={{ 
            color: '#856404', 
            margin: 0,
            fontSize: '0.9rem'
          }}>
            🚧 Under Development
          </p>
        </div>
      </div>
    </div>
  );
};

export default Routes;
